export const NavSkeleton = () => {
  return (
    <div className="flex flex-col gap-2">
      <div className="h-10 w-full animate-pulse rounded-10 bg-system-white08" />
      <div className="h-10 w-full animate-pulse rounded-10 bg-system-white08" />
      <div className="h-10 w-full animate-pulse rounded-10 bg-system-white08" />
    </div>
  );
};
